export { EmailConfirmation } from './EmailConfirmation'
export { EmailConfirmation as EmailConfirmationPage } from './EmailConfirmation'
